import { Box, CollapsibleIconButton, styled, Typography } from '@chronosphereio/chrono-ui';

export interface ContentWithLegendCollapseProps {
  /**
   * Set to `true` to show a button for collapsing/expanding the legend when using a `Bottom`-positioned
   * legend.
   *
   * Strongly recommend setting the `layoutStrategy` to `flex-height` when using this feature to
   * ensure the overall content shrinks when collapsing the legend.
   */
  show?: boolean;
  /**
   * When set, this text will be shown to the right of the collapse/expand button and will also
   * be clickable to collapse/expand the legend.
   */
  title?: string;
  /**
   * Current collapsed state of the legend.
   */
  isCollapsed: boolean;
  /**
   * Function that toggles the collapsed state.
   */
  toggleCollapsed: () => void;
}

export function ContentWithLegendCollapse({
  show,
  isCollapsed,
  toggleCollapsed,
  title,
}: ContentWithLegendCollapseProps) {
  if (!show) {
    return null;
  }

  // Used for language in the aria-label.
  const labelName = title ?? 'legend';

  return (
    <ContentWithLegendCollapseWrapper onClick={toggleCollapsed}>
      <CollapsibleIconButton collapsed={isCollapsed} ariaLabelSubject={labelName} size="medium" noPadding />
      {title && <Typography variant="h4">{title}</Typography>}
    </ContentWithLegendCollapseWrapper>
  );
}

const ContentWithLegendCollapseWrapper = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    cursor: 'pointer',
  };
});
